/* Maison Solenuit : dates de livraison estimées, sur la fiche et dans le panier (étape 39).
   Calcul repris tel quel de la maquette (app.js du 10/10/2026). Fourchettes en jours
   ouvrés lues dans l'attribut data-ms-jours-ouvres="min,max", posé en Liquid depuis le champ produit
   custom.livraison_jours_ouvres (estimation de l'atelier plus 1 jour de marge). Jours ouvrés : du lundi au vendredi, hors
   jours fériés de France et du pays de l'atelier ; le jour de la commande ne compte pas. Date du jour : celle de Paris.
   Sans Intl, sans fourchette valide ou en cas d'erreur, le texte en jours posé par le Liquid reste affiché. */
(function () {
  'use strict';

  var JOUR = 864e5;
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var SEMAINE = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var paques = function (an) {   /* dimanche de Pâques, calendrier grégorien (méthode de Meeus, Jones et Butcher) */
    var a = an % 19, b = Math.floor(an / 100), c = an % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return Date.UTC(an, Math.floor(n / 31) - 1, n % 31 + 1);
  };
  var cleJour = function (t) { return new Date(t).toISOString().slice(0, 10); };
  var FERIES = {};
  var feriesDe = function (an) {
    if (FERIES[an]) return FERIES[an];
    var f = {}, p = paques(an);
    var fixe = function (x) { f[cleJour(Date.UTC(an, x[0] - 1, x[1]))] = true; };
    var depuisPaques = function (n) { f[cleJour(p + n * JOUR)] = true; };
    /* France : 1er janvier, lundi de Pâques, 1er et 8 mai, Ascension, lundi de Pentecôte, 14 juillet, 15 août,
       1er et 11 novembre, Noël */
    [[1, 1], [5, 1], [5, 8], [7, 14], [8, 15], [11, 1], [11, 11], [12, 25]].forEach(fixe);
    [1, 39, 50].forEach(depuisPaques);
    /* pays de l'atelier, en plus : Vendredi saint, 23 et 24 juin, 24, 26 et 31 décembre ; 4 mai et 18 novembre, reportés
       au lundi s'ils tombent un samedi ou un dimanche (les fêtes du dimanche de sa liste ne changent rien) */
    depuisPaques(-2);
    [[6, 23], [6, 24], [12, 24], [12, 26], [12, 31]].forEach(fixe);
    [[5, 4], [11, 18]].forEach(function (x) {
      var t = Date.UTC(an, x[0] - 1, x[1]), j = new Date(t).getUTCDay();
      f[cleJour(j === 6 ? t + 2 * JOUR : j === 0 ? t + JOUR : t)] = true;
    });
    return (FERIES[an] = f);
  };
  var ouvre = function (t) { var d = new Date(t), j = d.getUTCDay(); return j !== 0 && j !== 6 && !feriesDe(d.getUTCFullYear())[cleJour(t)]; };
  var plusOuvres = function (t, n) { while (n > 0) { t += JOUR; if (ouvre(t)) n -= 1; } return t; };
  var aujourdhui = function () {   /* le jour qu'il est à Paris, à minuit UTC */
    var p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day);
  };
  var fourchette = function (o, depuis) { var t = depuis == null ? aujourdhui() : depuis; return [plusOuvres(t, o[0]), plusOuvres(t, o[1])]; };
  var quantieme = function (d) { return d.getUTCDate() === 1 ? '1er' : String(d.getUTCDate()); };
  var entreLe = function (f) {   /* fiche : « entre le jeudi 22 et le mardi 27 octobre » */
    var a = new Date(f[0]), b = new Date(f[1]), meme = a.getUTCMonth() === b.getUTCMonth();
    return 'entre le ' + SEMAINE[a.getUTCDay()] + ' ' + quantieme(a) + (meme ? '' : ' ' + MOIS[a.getUTCMonth()]) +
      ' et le ' + SEMAINE[b.getUTCDay()] + ' ' + quantieme(b) + ' ' + MOIS[b.getUTCMonth()];
  };
  var duAu = function (f) {   /* panier : « du 22 au 27 octobre » */
    var a = new Date(f[0]), b = new Date(f[1]), meme = a.getUTCMonth() === b.getUTCMonth();
    return 'du ' + quantieme(a) + (meme ? '' : ' ' + MOIS[a.getUTCMonth()]) + ' au ' + quantieme(b) + ' ' + MOIS[b.getUTCMonth()];
  };
  var sansErreur = function (f) { try { return f(); } catch (e) { return ''; } };
  window.msLivraison = { fourchette: fourchette, entreLe: entreLe, duAu: duAu, ouvre: ouvre, paques: paques };   /* pour verifier_dates.py */

  /* fourchette lue sur l'élément : deux entiers, 1 ≤ min ≤ max ≤ 30, sinon rien (une valeur vide donnerait la date du jour) */
  function lire(e) {
    var m = /^(\d{1,2}),(\d{1,2})$/.exec(e.getAttribute('data-ms-jours-ouvres') || '');
    if (!m) return null;
    var a = +m[1], b = +m[2];
    return a >= 1 && a <= b && b <= 30 ? [a, b] : null;
  }

  function remplir() {
    var liste = document.querySelectorAll('[data-ms-jours-ouvres]:not([data-ms-fait])');
    for (var i = 0; i < liste.length; i++) {
      var e = liste[i];
      e.setAttribute('data-ms-fait', '1');   /* avant d'écrire : nos propres changements ne relancent rien */
      var o = lire(e), cible = e.querySelector('[data-ms-dates]');
      if (!o || !cible) continue;
      if (e.classList.contains('ms-livraison-panier')) {
        var court = sansErreur(function () { return duAu(fourchette(o)); });
        if (court) cible.textContent = court;
      } else {
        var dates = sansErreur(function () { return entreLe(fourchette(o)); });
        if (!dates) continue;
        var s = document.createElement('strong');
        s.textContent = dates;
        cible.textContent = 'livraison estimée ';
        cible.appendChild(s);
      }
    }
  }

  /* le thème redessine le panier depuis le serveur après chaque ajout ou changement : on refait la ligne à chaque fois */
  function suivre(racine) {
    if (racine && window.MutationObserver) new MutationObserver(remplir).observe(racine, { childList: true, subtree: true });
  }

  /* page panier : l'éditeur du thème peut remplacer tout #main-cart-footer ; on suit le nouveau, une seule fois */
  var pied = null;
  function suivrePied() {
    var e = document.getElementById('main-cart-footer');
    if (e !== pied) { pied = e; suivre(e); }
  }

  function demarrer() {
    remplir();
    suivre(document.querySelector('cart-drawer'));
    suivrePied();
    document.addEventListener('shopify:section:load', function () { remplir(); suivrePied(); });   /* éditeur du thème */
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
